<div class="stakeholders-info-section-title">
  {{ "TASKS.SIDEBAR.STAKEHOLDERS" | translate }}
</div>
<div class="stakeholders-info-section-content">
  <div class="stakeholders-info-section-content-wrapper">
    @for (
      stakeholder of formattedStakeholders;
      track index;
      let isLast = $last;
      let index = $index
    ) {
      <div
        class="stakeholders-info-section-content-item"
        [class.border-0]="isLast"
        [class.stakeholders-info-section-content-item-bold]="
          stakeholder.isCurrentUser || stakeholder.roleName === 'owner' || false
        "
      >
        <div class="role-position">
          {{ (("ROLES." + stakeholder.roleName) | uppercase) | translate }}
        </div>
        <div class="align-self-end text-truncate flex-grow-1">
          {{ stakeholder.userName }}
          {{ stakeholder.isCurrentUser ? "(You)" : "" }}
        </div>
        @if (stakeholder.depName) {
          <div
            class="align-self-end text-truncate dep-name d-flex justify-content-between"
          >
            <span class="text-truncate flex-grow-1">{{
              stakeholder.depName
            }}</span>
            @if (stakeholder.depCount > 1) {
              <div class="dep-count">
                <span>+{{ stakeholder.depCount - 1 }}</span>
                <svg-icon
                  color="var(--color-light-mode-main)"
                  name="multiple-links"
                ></svg-icon>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (showEmptyPlaceholder && !formattedStakeholders.length) {
      <div class="align-self-center">
        <span>
          {{ "NO_DATA" | translate }}
        </span>
      </div>
    }
  </div>
</div>
